import * as React from "react";
import {Redirect} from "react-router";
import {PathsMap} from "../app/PageRouting";

export function UserRequiredRedirect() {
    return <Redirect to={PathsMap.SIGN_IN} />;
}